import Viewer from './MultiChoiceViewer';
import MultiChoiceEditor from './MultiChoiceEditor';

export const MultiChoiceViewer = Viewer;
export default MultiChoiceEditor;
